import { Component, DestroyRef, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NetworkService } from '#services';

type NetworkIframeMessage =
  | { type: 'ontology-network-data'; payload: unknown }
  | { type: 'ontology-network-unavailable' };

@Component({
  selector: 'app-network-dynamic',
  imports: [],
  templateUrl: './network-dynamic.component.html',
  styleUrl: './network-dynamic.component.scss',
})
export class NetworkDynamicComponent {
  private _networkService = inject(NetworkService);
  private _destroyRef = inject(DestroyRef);

  @ViewChild('networkFrame') private _networkFrame?: ElementRef<HTMLIFrameElement>;

  private _frameLoaded = signal<boolean>(false);
  private _pendingMessage = signal<NetworkIframeMessage | null>(null);

  constructor() {
    this._loadNetworkMap();
  }

  onFrameLoad(): void {
    this._frameLoaded.set(true);
    this._postMessageToFrame();
  }

  private _loadNetworkMap(): void {
    this._networkService
      .getOkanNetworkDiagram()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (payload) => {
          if (payload) {
            this._pendingMessage.set({ type: 'ontology-network-data', payload });
          } else {
            this._pendingMessage.set({ type: 'ontology-network-unavailable' });
          }
          this._postMessageToFrame();
        },
        error: () => {
          this._pendingMessage.set({ type: 'ontology-network-unavailable' });
          this._postMessageToFrame();
        },
      });
  }

  private _postMessageToFrame(): void {
    if (!this._frameLoaded()) {
      return;
    }

    const message = this._pendingMessage();
    if (!message) {
      return;
    }

    const frameWindow = this._networkFrame?.nativeElement.contentWindow;
    if (!frameWindow) {
      return;
    }

    frameWindow.postMessage(message, window.location.origin);
  }
}
